var map = {
	"./categories/accessories.svg": 6786,
	"./categories/bags.svg": 82113,
	"./categories/clothing.svg": 56304,
	"./categories/home-and-living.svg": 93509,
	"./categories/home-decor.svg": 82185,
	"./categories/paper.svg": 25458,
	"./categories/store.svg": 28835,
	"./categories/wall-art.svg": 2060,
	"./connect-store.svg": 24797,
	"./connect-store_inactive.svg": 98383,
	"./create-athletic-crop-top.svg": 28463,
	"./create-athletic-crop-top_inactive.svg": 6845,
	"./create-baby-youth-leggings.svg": 10237,
	"./create-baby-youth-leggings_inactive.svg": 44175,
	"./create-beanie.svg": 32046,
	"./create-beanie_inactive.svg": 38094,
	"./create-book.svg": 86965,
	"./create-book_inactive.svg": 35159,
	"./create-canvas-print.svg": 85376,
	"./create-canvas-print_inactive.svg": 31364,
	"./create-capris.svg": 64704,
	"./create-capris_inactive.svg": 47908,
	"./create-coaster.svg": 68289,
	"./create-coaster_inactive.svg": 77331,
	"./create-crewneck-sweatshirt.svg": 99833,
	"./create-crewneck-sweatshirt_inactive.svg": 26043,
	"./create-day-tote.svg": 60123,
	"./create-day-tote_inactive.svg": 98377,
	"./create-desk-mat.svg": 67756,
	"./create-desk-mat_inactive.svg": 1408,
	"./create-digital-art-print.svg": 36384,
	"./create-digital-art-print_inactive.svg": 77796,
	"./create-draped-kimono.svg": 55708,
	"./create-draped-kimono_inactive.svg": 54768,
	"./create-drawstring-bag.svg": 89614,
	"./create-drawstring-bag_inactive.svg": 30894,
	"./create-dress.svg": 89775,
	"./create-dress_inactive.svg": 37597,
	"./create-duvetcover.svg": 63349,
	"./create-duvetcover_inactive.svg": 31383,
	"./create-fabric.svg": 26353,
	"./create-fabric_inactive.svg": 67523,
	"./create-fine-art-print.svg": 13704,
	"./create-fine-art-print_inactive.svg": 19055,
	"./create-fitted-polo-shirt.svg": 6524,
	"./create-fitted-polo-shirt_inactive.svg": 90320,
	"./create-flare-dress.svg": 18444,
	"./create-flare-dress_inactive.svg": 34387,
	"./create-flare-skirt.svg": 74604,
	"./create-flare-skirt_inactive.svg": 23776,
	"./create-headband.svg": 6065,
	"./create-headband_inactive.svg": 49187,
	"./create-kimono.svg": 65451,
	"./create-kimono_inactive.svg": 5113,
	"./create-leggings.svg": 15958,
	"./create-leggings_inactive.svg": 90566,
	"./create-loose-tank-top.svg": 42379,
	"./create-loose-tank-top_inactive.svg": 21977,
	"./create-makeup-bag.svg": 8114,
	"./create-makeup-bag_inactive.svg": 20546,
	"./create-men-underwear.svg": 238,
	"./create-men-underwear_inactive.svg": 21134,
	"./create-mini-shorts.svg": 69361,
	"./create-mini-shorts_inactive.svg": 97571,
	"./create-origami-tote.svg": 33019,
	"./create-origami-tote_inactive.svg": 48233,
	"./create-peignoir.svg": 8171,
	"./create-peignoir_inactive.svg": 37369,
	"./create-pencil-case.svg": 91174,
	"./create-pencil-case_inactive.svg": 58454,
	"./create-permanent-sticker.svg": 28098,
	"./create-permanent-sticker_inactive.svg": 86034,
	"./create-pillow.svg": 14006,
	"./create-pillow_inactive.svg": 33291,
	"./create-placemat.svg": 66379,
	"./create-placemat_inactive.svg": 30425,
	"./create-racerback-tank-top.svg": 33651,
	"./create-racerback-tank-top_inactive.svg": 49169,
	"./create-scarf.svg": 42361,
	"./create-scarf_inactive.svg": 55227,
	"./create-shirt-bellacanvas-3001.svg": 50798,
	"./create-shirt-bellacanvas-3001_inactive.svg": 53134,
	"./create-shirt-bellacanvas-6004.svg": 91012,
	"./create-shirt-bellacanvas-6004_inactive.svg": 48968,
	"./create-shorts.svg": 28711,
	"./create-shorts_inactive.svg": 13445,
	"./create-skirt.svg": 45071,
	"./create-skirt_inactive.svg": 20285,
	"./create-spiralnotebook.svg": 52238,
	"./create-spiralnotebook_inactive.svg": 16014,
	"./create-stainless-steel-tumbler.svg": 26662,
	"./create-stainless-steel-tumbler_inactive.svg": 24950,
	"./create-stainless-steel-water-bottle.svg": 43603,
	"./create-stainless-steel-water-bottle_inactive.svg": 46257,
	"./create-stationery-card.svg": 48487,
	"./create-stationery-card_inactive.svg": 31493,
	"./create-tank-top.svg": 26876,
	"./create-tank-top_inactive.svg": 87024,
	"./create-tapestry.svg": 99952,
	"./create-tapestry_inactive.svg": 28948,
	"./create-tote-bag.svg": 5453,
	"./create-tote-bag_inactive.svg": 32607,
	"./create-unisex-joggers.svg": 37778,
	"./create-unisex-joggers_inactive.svg": 51842,
	"./create-unisex-polo-shirt.svg": 81670,
	"./create-unisex-polo-shirt_inactive.svg": 45398,
	"./create-vegan-leather-backpack.svg": 69136,
	"./create-vegan-leather-backpack_inactive.svg": 28372,
	"./create-vegan-leather-crossbody-purse.svg": 36996,
	"./create-vegan-leather-crossbody-purse_inactive.svg": 1800,
	"./create-vegan-leather-makeup-bag.svg": 65630,
	"./create-vegan-leather-makeup-bag_inactive.svg": 15166,
	"./create-vegan-leather-tote-bag.svg": 32785,
	"./create-vegan-leather-tote-bag_inactive.svg": 10307,
	"./create-wall-art.svg": 67866,
	"./create-wall-art_inactive.svg": 47162,
	"./create-women-underwear.svg": 62336,
	"./create-women-underwear_inactive.svg": 76004,
	"./create-wood-print.svg": 74091,
	"./create-wood-print_inactive.svg": 48025,
	"./create-wrap-skirt.svg": 9020,
	"./create-wrap-skirt_inactive.svg": 40656,
	"./create-yoga-capris.svg": 21061,
	"./create-yoga-capris_inactive.svg": 75303,
	"./create-yoga-leggings.svg": 68899,
	"./create-yoga-leggings_inactive.svg": 2561,
	"./create-yoga-shorts.svg": 42438,
	"./create-yoga-shorts_inactive.svg": 14774,
	"./create-youth-leggings.svg": 36148,
	"./create-youth-leggings_inactive.svg": 83224,
	"./create-zipper-carry-all.svg": 47564,
	"./create-zipper-carry-all_inactive.svg": 94816,
	"./sell-product-one.svg": 65404,
	"./sell-product-one_inactive.svg": 656,
	"./sell-product-ten.svg": 40909,
	"./sell-product-ten_inactive.svg": 95519,
	"./setup-payment.svg": 18581,
	"./setup-payment_inactive.svg": 15063,
	"./sync-product-one.svg": 46649,
	"./sync-product-one_inactive.svg": 35707,
	"./sync-product-ten.svg": 65848,
	"./sync-product-ten_inactive.svg": 34508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92127;